"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientBookingCancelWindow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const app_1 = require("../../../app");
const calendar_1 = require("../../../calendar/calendar");
const helpers_1 = require("../../../utils/helpers");
const alert_box_1 = require("../../../widgets/alert_box");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const booking_show_1 = require("./booking_show");
const client_booking_table_1 = require("./client_booking_table");
exports.ClientBookingCancelWindow = {
    bookingId: 0,
    date: (0, moment_timezone_1.default)(),
    duration: 0,
    details: {},
    active: false,
    isProcessing: false,
    show(bookingId, date, duration) {
        exports.ClientBookingCancelWindow.bookingId = bookingId;
        exports.ClientBookingCancelWindow.active = true;
        exports.ClientBookingCancelWindow.isProcessing = false;
        exports.ClientBookingCancelWindow.date = date;
        exports.ClientBookingCancelWindow.duration = duration;
        this.details = {};
        this.simulate();
        mithril_1.default.redraw();
    },
    simulate() {
        if (this.bookingId) {
            app_1.App.get(`/bookings/${this.bookingId}/cancel_simulate`).then((data) => {
                this.details = data;
            });
        }
    },
    renderDetails() {
        if (this.details === undefined)
            return undefined;
        if (this.details.cancelation_details === undefined)
            return undefined;
        const cd = this.details.cancelation_details;
        if (cd && cd.should_display_message && cd.total_consumed > 0) {
            return (0, mithril_1.default)("strong", "Un dédommagement sera appliqué");
        }
        return undefined;
    },
    renderIfFree() {
        if (this.details === undefined)
            return undefined;
        if (this.details.cancelation_details === undefined)
            return undefined;
        let isFree = (this.details.cancelation_details.total_consumed == 0) &&
            (this.details.cancelation_details.total_free_minutes == 0);
        if (!isFree)
            return undefined;
        return (0, mithril_1.default)("p.has-text-success", { style: "font-size: 1.25em" }, "Cette annulation est gratuite et n'impute pas votre quota d'annulation gratuite");
    },
    renderIfFullyConsumed() {
        if (this.details === undefined)
            return undefined;
        if (this.details.cancelation_details === undefined)
            return undefined;
        let isFullyConsumed = this.details.cancelation_details.total_consumed == this.details.duration;
        if (!isFullyConsumed) {
            return undefined;
        }
        return (0, alert_box_1.alertBox)({
            level: "warning",
            content: [(0, mithril_1.default)("p", "Vous êtes sur le point d'annuler la réservation moins d'une heure avant, ", "cette opération n'est pas comprise dans votre quota d'annulations gratuites."), (0, mithril_1.default)("p", "Merci, à bientôt, Sésame")]
        });
    },
    renderContent() {
        return (0, mithril_1.default)("div", { class: "content" }, (0, form_for_1.columns)((0, mithril_1.default)("div", { style: "text-align: center;" }, (0, mithril_1.default)("p", { style: "font-size: 1.25em" }, mithril_1.default.trust(`Vous êtes sur le point de supprimer la réservation
                 <strong>#${this.bookingId}</strong> du <strong>${this.date.format("LLL")}</strong> d'une durée de <strong>${this.duration / 60} point(s)<strong>.`)), (0, mithril_1.default)("p", { style: "font-size: 1.25em" }, `L'opération est irreversible.`), this.renderDetails(), this.renderIfFree(), this.renderIfFullyConsumed())));
    },
    view(_node) {
        if (exports.ClientBookingCancelWindow.active) {
            let disabled = this.isProcessing ? true : undefined;
            return (0, modal_1.modalCard)({
                content: exports.ClientBookingCancelWindow.renderContent(),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, (0, mithril_1.default)("button", {
                    class: `button is-success ${this.isProcessing ? "is-loading" : ""}`,
                    disabled: disabled,
                    onclick: (evt) => {
                        evt.preventDefault();
                        exports.ClientBookingCancelWindow.isProcessing = true;
                        app_1.App.get(`/bookings/${this.details.id}/cancel`).then((_data) => {
                            client_booking_table_1.ClientBookingTable.fetch();
                            calendar_1.Calendar.refresh();
                            booking_show_1.BookingShow.fetch(this.details.id);
                            exports.ClientBookingCancelWindow.active = false;
                        }).finally(() => {
                            exports.ClientBookingCancelWindow.isProcessing = false;
                        });
                    }
                }, (0, helpers_1.iconSpan)("fa-check"), (0, mithril_1.default)("span", " Confirmer")), (0, mithril_1.default)("button", {
                    class: "button is-danger",
                    disabled: disabled,
                    onclick: (evt) => {
                        evt.preventDefault();
                        exports.ClientBookingCancelWindow.active = false;
                    }
                }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", " Ne pas annuler"))),
                isActive: exports.ClientBookingCancelWindow.active,
                onClose: () => { exports.ClientBookingCancelWindow.active = false; },
                title: "Confirmer annulation"
            });
        }
        return undefined;
    }
};
